import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'wire-frame';


@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor(private http: HttpClient, private common: CommonService) { }

  getPurchaseOrder(payload: (string | null) = null) {
    return this.http.get(
      this.common.getBaseUrl() + 'PurchaseOrder.php?action=PurchaseOrderList' + (payload ? '&list=all' : '')
    );
  }

  addPurchaseOrder(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPurchaseOrder";
    return this.http.post(this.common.getBaseUrl() + 'PurchaseOrder.php', payload);
  }

  updatePurchaseOrder(payload: any) {
    payload["action"] = "updatePurchaseOrder";
    return this.http.put(this.common.getBaseUrl() + 'PurchaseOrder.php', payload);
  }

  deletePurchaseOrder(payload: any) {
    payload["action"] = "deletePurchaseOrder";
    return this.http.put(this.common.getBaseUrl() + 'PurchaseOrder.php', payload);
  }
}
